<template>
  <vxe-modal v-model="visible" :loading="loading" :title="$t('title.receiptDetailEdit')" type="confirm" width="60%" @confirm="confirm">
    <vxe-form :data="detail" border size="medium" span="8" title-align="center" title-background title-bold>
      <vxe-form-item field="order.no" title="business.label.receiptOrderNo"/>
      <vxe-form-item field="supplier.name" span="16" title="business.label.supplier"/>
      <vxe-form-item field="item.no" title="business.label.itemNo"/>
      <vxe-form-item field="item.name" title="business.label.itemName"/>
      <vxe-form-item field="owner.name" title="business.label.owner"/>
      <vxe-form-item field="pack.specification" title="business.label.specification"/>
      <vxe-form-item field="pack.uom" title="business.label.uom"/>
      <vxe-form-item field="pack.factor" title="business.label.factor"/>
      <vxe-form-item field="lot.no" title="business.label.lot"/>
      <vxe-form-item field="lot.productionDate" title="business.label.productionDate"/>
      <vxe-form-item field="lot.validUntil" title="business.label.validUntil"/>
      <vxe-form-item field="storageRoom.name" title="business.label.storageRoom">
        <template #default>
          <vxe-input v-model="detail.storageRoom.name" :editable="false" style="width: 100%" @click="onStorageRoomSelect"/>
          <storage-room-modal ref="storageRoomModal" @change="onStorageRoomChange"/>
        </template>
      </vxe-form-item>
      <vxe-form-item field="container.no" title="business.label.containerNo">
        <template #default>
          <vxe-input v-model="detail.container.no" :editable="false" style="width: 100%" @click="onContainerSelect"/>
          <container-modal ref="containerModal" @change="onContainerChange"/>
        </template>
      </vxe-form-item>
      <vxe-form-item field="invoiceQuantity" title="business.label.invoiceQuantity">
        <template #default>
          <vxe-number-input v-model="detail.invoiceQuantity" :min="1" style="width: 100%"/>
        </template>
      </vxe-form-item>
    </vxe-form>
  </vxe-modal>
</template>
<script>
import api from '@/api'
import ContainerModal from '@/views/modal/ContainerModal.vue'
import StorageRoomModal from '@/views/modal/StorageRoomModal.vue'
import { post } from '@/api/Api'
import { StorageRoom } from '@/api/dto/common/StorageRoom'
import { Container } from '@/api/dto/common/Container'
import { Lot } from '@/api/dto/common/Lot'
import { Batch } from '@/api/dto/common/Batch'
import { Item } from '@/api/dto/common/Item'
import { Pack } from '@/api/dto/common/Pack'
import { Party } from '@/api/dto/common/Party'
import { ReceivingFactoryView } from '@/api/dto/view/ReceivingFactoryView'
import { ReceiptDetail, ReceiptOrder } from '@/api/dto/order/ReceiptOrder'
import { BaseObject } from '@/api/dto/BaseObject'

export default {
  name: 'ModifyModal',
  components: { ContainerModal, StorageRoomModal },
  data() {
    return {
      visible: false,
      loading: false,
      detail: new ReceiptDetail(),
      data: new ReceivingFactoryView()
    }
  },
  methods: {
    open(data) {
      this.detail = new ReceiptDetail(BaseObject.merge(data, 'detail'))
      this.data.order = new ReceiptOrder(data.order)
      this.data.detail = new ReceiptDetail(data.detail)
      this.data.owner = new Party(data.owner)
      this.data.supplier = new Party(data.supplier)
      this.data.item = new Item(data.item)
      this.data.pack = new Pack(data.pack)
      this.data.lot = new Lot(data.lot)
      this.data.batch = new Batch(data.batch)
      this.data.storageRoom = new StorageRoom(data.storageRoom)
      this.data.container = new Container(data.container)
      this.visible = true
    },
    onStorageRoomSelect() {
      this.$refs.storageRoomModal.open()
    },
    onStorageRoomChange(values) {
      this.data.storageRoom = new StorageRoom(values[0])
    },
    onContainerSelect() {
      this.$refs.containerModal.open({ available: true, physical: true, 'storageRoom.id': this.data.storageRoom.id })
    },
    onContainerChange(values) {
      this.data.container = new Container(values[0])
    },
    confirm() {
      this.loading = true
      const args = {
        id: this.data.detail.id,
        lot: this.data.lot.skipNulls(),
        batch: this.data.batch.skipNulls(),
        storageRoom: this.data.storageRoom.skipNulls(),
        container: this.data.container.skipNulls(),
        invoiceQuantity: this.data.detail.invoiceQuantity
      }
      post(api.receivingReceiverModify, { type: 'normalInboundReceiver' }, this.detail.toJSONObject()).then(res => {
        if (res.success) {
          this.$message.success(this.$t('message.saveSuccess'))
          this.$emit('success')
          this.visible = false
        }
      }).finally(() => this.loading = false)
    }
  }
}
</script>